<template>
    <div class="per-page-dropdown">
        <button
            type="button"
            class="per-page-dropdown__button"
            @click.stop="toggle"
        >
            <span class="per-page-dropdown__value">{{ value }}</span>
            <span class="per-page-dropdown__caret">{{ open ? "▴" : "▾" }}</span>
        </button>
        <div v-if="open" class="per-page-dropdown__menu">
            <button
                v-for="option in options"
                :key="`per-page-${option}`"
                type="button"
                class="per-page-dropdown__option"
                :class="{ 'per-page-dropdown__option--active': option === value }"
                @click.stop="select(option)"
            >
                {{ option }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "PerPageDropdown",
    props: {
        value: {
            type: Number,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
    },
    emits: ["select"],
    data() {
        return {
            open: false,
        };
    },
    mounted() {
        document.addEventListener("click", this.onDocumentClick);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.onDocumentClick);
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
        select(option) {
            this.$emit("select", option);
            this.open = false;
        },
        onDocumentClick(event) {
            if (!this.open) return;
            const root = this.$el;
            if (root && !root.contains(event.target)) {
                this.open = false;
            }
        },
    },
};
</script>

<style scoped>
.per-page-dropdown {
    position: relative;
}
.per-page-dropdown__button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 32px;
    padding: 0 10px;
    border: 1px solid #cfe2e8;
    background: #fff;
    border-radius: 2px;
    font-size: 14px;
    color: #111827;
}
.per-page-dropdown__button:focus {
    outline: none;
}
.per-page-dropdown__caret {
    font-size: 14px;
    color: #6b7280;
}
.per-page-dropdown__menu {
    position: absolute;
    right: 0;
    bottom: calc(100% + 6px);
    min-width: 100%;
    background: #fff;
    border: 1px solid #cfe2e8;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    padding: 6px 0;
    z-index: 200;
}
.per-page-dropdown__option {
    width: 100%;
    text-align: left;
    padding: 8px 10px;
    border: none;
    background: transparent;
    font-size: 14px;
    color: #111827;
    cursor: pointer;
}
.per-page-dropdown__option:hover {
    background: #f3f4f6;
}
.per-page-dropdown__option--active {
    font-weight: 700;
}
</style>
